import { HistoryService, RequestHistory } from '../api';

interface HistoryProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: RequestHistory[]; total: number }>;
}

export const historyDataProvider: HistoryProviderResource = {
  getList: async (resource, params) => {
    const { items } = await HistoryService.requestHistoryList();
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: items,
      total: items.length,
    };
  },
};
